import { render, staticRenderFns } from "./u-tooltip-outlined-pill.vue?vue&type=template&id=4ac27baa&scoped=true"
import script from "./u-tooltip-outlined-pill.vue?vue&type=script&lang=js"
export * from "./u-tooltip-outlined-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac27baa",
  null
  
)

export default component.exports